import React from "react";
import * as FBLiveActions from './FacebookLiveActions';
import Service from '../service/Service';
const service = new Service();

export default function ShareOptions({ data, eleRef }) {
    return (
        <div className="sharing-options">
            <ul>
                <li className="facebook-share left" onClick={() => FBLiveActions.shareArticle('facebook', global.redirect_url + 'live-sessions/' + service.replaceSymbols(data.videoTitle) + '/' + eleRef.state.videoID)}>
                    <div className="M16_61 social-share">
                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png" className="loadingImg facebookimg" alt="Facebook Icon" title="Facebook Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => FBLiveActions.shareArticle('twitter', global.redirect_url + 'live-sessions/' + service.replaceSymbols(data.videoTitle) + '/' + eleRef.state.videoID)}>
                    <div className="M16_61 social-share">
                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png" className="loadingImg twitterimg" alt="Twitter Icon" title="Twitter Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => FBLiveActions.shareArticle('pintrest', global.redirect_url + 'live-sessions/' + service.replaceSymbols(data.videoTitle) + '/' + eleRef.state.videoID)}>
                    <div className="M16_61 social-share">
                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png" className="loadingImg pintrestimg" alt="Pintrest Icon" title="Pintrest Icon" />
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => FBLiveActions.shareArticle('whatsapp', global.redirect_url + 'live-sessions/' + service.replaceSymbols(data.videoTitle) + '/' + eleRef.state.videoID)}>
                    <div className="M16_61 social-share">
                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png" className="loadingImg whatsappimg" alt="Whatsapp Icon" title="Whatsapp Icon" />
                    </div>
                </li>
            </ul>
        </div>
    );
}
